import { render, staticRenderFns } from "./BindMember.vue?vue&type=template&id=28585b38&"
import script from "./BindMember.vue?vue&type=script&lang=js&"
export * from "./BindMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports